import {Paper as MuiPaper, styled, alpha} from '@mui/material';
import React from 'react';

type AppPaperVariant = 'outlined' | 'elevated' | 'flat';

interface AppPaperProps extends Omit<React.ComponentProps<typeof MuiPaper>, 'variant'> {
  appVariant?: AppPaperVariant;
}

const getVariantStyles = (variant: AppPaperVariant, theme: any) => {
  switch (variant) {
    case 'elevated':
      return {
        border: 'none',
        boxShadow: theme.palette.mode === 'dark'
          ? '0px 2px 8px rgba(0, 0, 0, 0.4)'
          : '0px 2px 8px rgba(0, 0, 0, 0.08)',
      };
    case 'flat':
      return {
        border: 'none',
        backgroundColor: alpha(
          theme.palette.mode === 'dark'
            ? theme.palette.common.white
            : theme.palette.common.black,
          0.02
        ),
      };
    case 'outlined':
    default:
      return {
        border: `1px solid ${
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, 0.08)'
            : 'rgba(0, 0, 0, 0.08)'
        }`,
        boxShadow: 'none',
      };
  }
};

const StyledPaper = styled(MuiPaper, {
  shouldForwardProp: (prop) => prop !== 'appVariant',
})<{appVariant?: AppPaperVariant}>(({theme, appVariant = 'outlined'}) => ({
  overflow: 'hidden',
  borderRadius: 12,
  backgroundImage: 'none',
  ...getVariantStyles(appVariant, theme),
}));

const AppPaper = React.forwardRef<HTMLDivElement, AppPaperProps>(
  ({appVariant = 'outlined', ...props}, ref) => {
    return <StyledPaper ref={ref} appVariant={appVariant} variant="outlined" {...props} />;
  }
);

AppPaper.displayName = 'AppPaper';

export default AppPaper;
